import { useState } from "react";
import { Shield } from "lucide-react";

export function BraveBadge() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        data-testid="brave-badge"
        title="only the brave"
        className="shrink-0 inline-flex items-center justify-center w-[26px] h-[26px] align-middle transition-colors duration-200 hover:opacity-100 opacity-80"
        style={{ border: "1px solid var(--border)", color: "var(--accent)" }}
      >
        <Shield size={14} strokeWidth={2} />
      </button>
      {open && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center p-6 fade-in"
          style={{ background: "rgba(0,0,0,0.7)" }}
          onClick={(e) => { e.stopPropagation(); setOpen(false); }}
          data-testid="brave-overlay"
        >
          <div
            className="w-full max-w-sm p-8"
            style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }}
            onClick={(e) => e.stopPropagation()}
            data-testid="brave-modal"
          >
            <div className="flex justify-between items-start mb-6">
              <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>only the brave</span>
              <button onClick={() => setOpen(false)} data-testid="brave-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
            </div>
            <p className="text-base" style={{ color: "var(--text-secondary)" }} data-testid="brave-modal-text">I made it onto only the brave</p>
          </div>
        </div>
      )}
    </>
  );
}
